import Axios from 'axios';
import {APIBASE_URL, BANNER_URL} from '../config/cacheKey';
import {IBannersResponse, IGetBannersRequest} from '../models/banner.model';
import {ApiResultModel} from '../models/common.model';

export const GetBanners = (
    data: IGetBannersRequest
): Promise<IBannersResponse[]> => {
    return Axios.post<ApiResultModel<IBannersResponse[]>>(
        APIBASE_URL + BANNER_URL + '/GetBanners',
        data
    ).then((result) => {
        return result.data.data;
    });
};
